import { dashboardBFF } from "../axios-instances";
import { GetAvailableLicensesResponse } from "./types";
import { getServices } from "src/logs";

const { logger } = getServices();

export const getAvailableLicenses = async () => {
  try {
    const url = "/api/license-information";
    const response = await dashboardBFF.get(url, {
      headers: {
        "Content-type": "application/json"
      }
    });

    if (response.status >= 200 && response.status < 300) {
      const availableLicenses = response.data as GetAvailableLicensesResponse;
      return availableLicenses;
    }

    if (response.status === 204) {
      console.info(`GET ${url} returned 204 No Content.`);
      return { licensesAvailable: [] } as GetAvailableLicensesResponse;
    }

    throw new Error(
      `Unexpected status code ${response.status} while fetching available licenses for user`
    );
  } catch (error) {
    const err = error as Error;
    if (!err.message.includes("204")) {
      logger.logError({
        message: "getAvailablelicenses - Exception",
        properties: {
          name: err.name,
          message: err.message,
          stack: err.stack || "unknown stack",
          cause: String(err.cause ?? "unknown cause")
        }
      });
    }
    throw error;
  }
};

